import { countryProfile, nationalIdCountryOf, nationalIdHint, nationalIdLabel, nationalIdPlaceholder } from '@his/shared';
import { display } from './utils';

export interface NationalIdText {
  label: string;
  hint: string;
  placeholder: string;
}

export function nationalIdText(): NationalIdText {
  const country = nationalIdCountryOf({ country: display.country, timezone: display.timezone });
  return { label: nationalIdLabel(country), hint: nationalIdHint(country), placeholder: nationalIdPlaceholder(country) };
}

export function phonePlaceholder(): string {
  const country = nationalIdCountryOf({ country: display.country, timezone: display.timezone });
  return countryProfile(country).phone.example || '03001234567';
}
